<script setup lang="ts">
const { page } = defineProps<{ page: Page, centered: boolean }>()

// Notes about padding:
// - Removed mt-8 for consistency with non-content page titles

</script>

<template>
  <ContentBlockViewPartialContainer
    v-if="page.showTitleOnPage"
    background-color="transparent"
  >
    <PageTitle
      title-style="large"
      class="mb-4"
    >
      {{
        page.title
      }}
    </PageTitle>
  </ContentBlockViewPartialContainer>
</template>
